import styled from "styled-components";
import Icon from "../../../../../../base/icons/icon/index.js";
import { FlexMixin, FontMixin } from "../../../../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius } from "../../../../../../../styles/common/mixins/logical.styled.js";
import pricesDesktopThemes from "./themes/index.js";
export const PricesWrapper = styled.div.withConfig({
    displayName: "styled__PricesWrapper",
    componentId: "sc-dde541d2-0"
})`
	${FlexMixin({
    direction: 'column',
    align: 'flex-end'
})}
	flex-grow: 1;
	color: ${({ theme  })=>theme.colors.secondary.base};
`;
export const PriceTopDesktop = styled.div.withConfig({
    displayName: "styled__PriceTopDesktop",
    componentId: "sc-dde541d2-1"
})`
	.from {
		${FontMixin({
    size: 'small',
    height: 'small',
    weight: 'light'
})}

		&::after {
			content: ' ';
		}

		${({ theme  })=>theme.media.down('tablet')} {
			font-weight: 400;
			line-height: 20px;
		}
	}

	.old-price {
		${FontMixin({
    size: 'medium',
    height: 'medium',
    weight: 'regular'
})}
		text-decoration: line-through;
	}
	${({ theme  })=>pricesDesktopThemes[theme.id]?.PriceTopDesktop?.()}
`;
export const PriceCurrentDesktop = styled.span.withConfig({
    displayName: "styled__PriceCurrentDesktop",
    componentId: "sc-dde541d2-2"
})`
	color: ${({ theme  })=>theme.colors.secondary.base};
	${FontMixin({
    size: 'largest',
    height: 'largest',
    weight: 'medium'
})}

	${({ theme  })=>theme.media.down('tablet')} {
		font-size: 28px;
		line-height: 38px;
	}

	${({ theme  })=>pricesDesktopThemes[theme.id]?.PriceCurrentDesktop?.()}
`;
export const PricePaxValueDesktop = styled.span.withConfig({
    displayName: "styled__PricePaxValueDesktop",
    componentId: "sc-dde541d2-3"
})`
	color: ${({ theme  })=>theme.colors.grays.dark};
	${FontMixin({
    size: 'medium',
    height: 'base',
    weight: 'regular'
})}

	& span::after {
		content: ' ';
	}
`;
export const PriceCaption = styled.div.withConfig({
    displayName: "styled__PriceCaption",
    componentId: "sc-dde541d2-4"
})`
	color: ${({ theme  })=>theme.colors.grays.dark};
	${FontMixin({
    size: 'small',
    weight: 'regular',
    height: 'base'
})}
`;
export const PriceTopDealDesktop = styled.div.withConfig({
    displayName: "styled__PriceTopDealDesktop",
    componentId: "sc-dde541d2-5"
})`
	color: ${({ theme  })=>theme.colors.grays.dark};
	${FontMixin({
    size: 'small',
    weight: 'regular',
    height: 'medium'
})}
	margin-bottom: 4px;

	.discount {
		background-color: ${({ theme  })=>theme.colors.grays.base};
		color: ${({ theme  })=>theme.colors.white.base};
		${BorderRadius({
    all: '4px'
})}
		padding: 1px 4px;
		margin-right: 4px;

		&::after {
			content: '%';
		}
		&::before {
			content: '-';
		}
	}
	.old-price {
		text-decoration: line-through;
	}
`;
export const PriceCurrentDealDesktop = styled.div.withConfig({
    displayName: "styled__PriceCurrentDealDesktop",
    componentId: "sc-dde541d2-6"
})`
	color: ${({ theme  })=>theme.colors.white.base};
	${FlexMixin({
    align: 'center'
})}
	position: relative;
	${FontMixin({
    size: 'larger',
    weight: 'bold',
    height: 'large'
})}
	background-color: ${({ theme  })=>theme.colors.status.offer};
	padding: 0 12px 0 4px;
	max-height: 36px;
	min-height: 36px;
	margin-right: -12px;

	&::before {
		content: '';
		height: 0;
		position: absolute;
		top: 0;
		width: 0;
		border-bottom: 18px solid transparent;
		border-right: 12px solid ${({ theme  })=>theme.colors.status.offer};
		border-top: 18px solid transparent;
		left: -12px;
	}

	&.is-blackfriday {
		background-color: ${({ theme  })=>theme.colors.black.base};
	}

	&.is-blackfriday::before {
		border-right-color: ${({ theme  })=>theme.colors.black.base};
	}
`;
export const NoPrice = styled.div.withConfig({
    displayName: "styled__NoPrice",
    componentId: "sc-dde541d2-7"
})`
	${FlexMixin({
    justify: 'flex-end',
    align: 'center'
})}
	margin-left: auto;

	& > span {
		color: ${({ theme  })=>theme.colors.secondary.base};
		${FontMixin({
    size: 'medium',
    weight: 'regular',
    height: 'base'
})};
		margin-right: 8px;
		margin-bottom: 0;
		text-align: right;
	}

	& strong {
		display: block;
		color: ${({ theme  })=>theme.colors.grays.base};
		${FontMixin({
    size: 'medium',
    weight: 'regular',
    height: 'base'
})};
	}

	${Icon} {
		${FlexMixin({
    justify: 'center',
    align: 'center'
})}
		background-color: ${({ theme  })=>theme.colors.secondary.base};
		color: ${({ theme  })=>theme.colors.white.base};
		${BorderRadius({
    all: '50%'
})}
		width: 40px;
		min-width: 40px;
		height: 40px;
	}
`;

//# sourceMappingURL=styled.js.map